import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/app/pages/industryAnalysis/SectionHeading";
import "@/app/pages/industryAnalysis/industry.scss";
import { isNotUndefined, isNotUndefinedOrNull } from "@/shared/FunctionCore";
import {AdComponent, getAdDataWithAdSizeParsed } from "@/components/ads/AdComponent";
import { IsectionList, AdComponentParameter, industryProfileParameter, AdProperties } from "@/app/pages/industryAnalysis/ConfigAndInterface";

const Analysis = ({ description, activities }): JSX.Element => {
  const { t } = useTranslation();
  const onThisPageTitle = t("industryAnalysis.analysis.onThisPageTitle");
  const sectionHeading = t("industryAnalysis.analysis.sectionHeading");
  const industryActivities = t("industryAnalysis.analysis.industryActivities");
  const descriptionTitle = t("industryAnalysis.analysis.descriptionTitle");
  const itemsToShow = Number(t("industryAnalysis.analysis.itemsToShow"));
  const [expanded, setExpanded] = useState(false);
  const viewMoreRef = useRef<HTMLDivElement>(null);
  const profileList: IsectionList[] = t("industryAnalysis.analysis.profileList", { returnObjects: true });


  const [adTopLeftParameters, setAdTopLeftParameters] = useState<
    AdComponentParameter | undefined>();
  const [adBottomLeftParameters, setAdBottomLeftParameters] = useState<
    AdComponentParameter | undefined>();
  const [adTopBodyParameters, setAdTopBodyParameters] = useState<
    AdComponentParameter | undefined>();
  const [adBottomBodyParameters, setAdBottomBodyParameters] = useState<
    AdComponentParameter | undefined>();
  const [isMobile, setIsMobile] = useState(false);

  const parseAdData = (adData: any[] | string) => {
    if (typeof adData === "string") {
      return [window.JSON.parse(adData)];
    } else if (window.Array.isArray(adData)) {
      return adData.map((adObject) => window.JSON.parse(adObject));
    } else {
      return [];
    }
  };

   useEffect(() => {
    if (
      isNotUndefined(industryProfileParameter.tab1) &&
      isNotUndefined(industryProfileParameter.tab1.ad)
    ) {
      const adComponentParameter = {
        adData: parseAdData(industryProfileParameter.tab1.ad),
        identifier: "",
        properties: { ...industryProfileParameter.tab1 },
      };

      setAdTopLeftParameters(adComponentParameter);
    }

    if (
      isNotUndefined(industryProfileParameter.tab2) &&
      isNotUndefined(industryProfileParameter.tab2.ad)
    ) {
      const adComponentParameter = {
        adData: parseAdData(industryProfileParameter.tab2.ad),
        identifier: "",
        properties: { ...industryProfileParameter.tab2 },
      };

      setAdBottomLeftParameters(adComponentParameter);
    }

    if (
      isNotUndefined(industryProfileParameter.tab3) &&
      isNotUndefined(industryProfileParameter.tab3.ad)
    ) {
      const adComponentParameter = {
        adData: parseAdData(industryProfileParameter.tab3.ad),
        identifier: "",
        properties: { ...industryProfileParameter.tab3 },
      };

      setAdTopBodyParameters(adComponentParameter);
    }

    if (
      isNotUndefined(industryProfileParameter.tab4) &&
      isNotUndefined(industryProfileParameter.tab4.ad)
    ) {
      const adComponentParameter = {
        adData: parseAdData(industryProfileParameter.tab4.ad),
        identifier: "",
        properties: { ...industryProfileParameter.tab4 },
      };

      setAdBottomBodyParameters(adComponentParameter);
    }

    setIsMobile(window.matchMedia("screen and (max-width: 767px)").matches);
  }, []);

  const handleViewMoreLess = () => {
    if(expanded) {
      window.scrollTo({
        top: viewMoreRef.current?.offsetTop,
        behavior: 'smooth'
      }); 
    }
    setExpanded(!expanded);
  };

  const ad = (properties: AdProperties): JSX.Element => {
    const { adComponentParameter } = properties;
  
    if (isNotUndefinedOrNull(adComponentParameter)) {
      const { adDataWithAdSizeParsed, goal, windowGoogletag } =
        getAdDataWithAdSizeParsed(adComponentParameter);
  
      // TODO
      if (
        isNotUndefinedOrNull(adDataWithAdSizeParsed) &&
        window.Number(adDataWithAdSizeParsed.adWidth) < goal
      ) {
        return (
          <AdComponent
            adDataWithAdSizeParsed={adDataWithAdSizeParsed}
            windowGoogletag={windowGoogletag}
          />
        );
      }
    }
  
    return <></>;
    };
  return (
    <div className="container">
      <div className="row pad-lr-0">
        <div className="industryProfileWrapper">
          <SectionHeading heading={sectionHeading} />
          <div className="industryProfilecontainer">
            <div className={`row industry_profile_details pad-lr-0`}>
              <div className={"col-md-3 sidebar"}>
                <div className="codes-title">{onThisPageTitle}</div>
                <div className="profile-list">
                  <ul className="itemList">
                    {profileList.map((listItem) => {
                        return (
                          <li key={listItem["aTitle"]}>
                            <a
                              className={
                                "jump-link company-profile-anchor sideLink"
                              }
                              href={listItem["anchorId"]}
                            >
                              {listItem["aTitle"]}
                            </a>
                          </li>
                        );
                      return <></>;
                    })}
                  </ul>
                </div>
               {isMobile ? (
                  <></>
                ) : (
                  <div>
                    
                    {ad({ 'adComponentParameter': adTopLeftParameters })}

                    {ad({ 'adComponentParameter': adBottomLeftParameters })}
                  </div>
                )}
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-8 pad-l-0">
                <div className="module" ref={viewMoreRef}>
                  <h3 className={"title first"}>{descriptionTitle}</h3>

                  <div className="text line-height-one-seven">{description}</div>
                  {isMobile ? (
                    <div>
                      {ad({ 'adComponentParameter': adTopBodyParameters })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="module">
                  <h3 className="title">{industryActivities}</h3>
                  <div className="text">
                    {expanded
                      ? activities.map((activity: string) => (
                          <>
                            <div key={activity} className="marginBottomZeroPointFour">{activity}</div>
                          </>
                        ))
                      : activities
                          .slice(0, itemsToShow)
                          .map((activity: string) => (
                            <>
                              <div key={activity} className="marginBottomZeroPointFour">{activity}</div>
                            </>
                          ))}
                  </div>
                  <button
                    className="sideLink show-more viewMore pad-lr-0 marginTopZeroPointFour"
                    aria-label="Show more industries"
                    onClick={handleViewMoreLess}
                  >
                    {expanded
                      ? "View fewer industry activities"
                      : `View ${activities.length - itemsToShow} industry activities`}
                  </button>
                  {isMobile ? (
                    <div>
                      {ad({ 'adComponentParameter': adBottomBodyParameters })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analysis;
